import styles from './ReferralFAQSection.module.scss';
import { useGetReferralsInfo } from 'src/hooks';
import { AVAILABLE_FEATURES_LIST } from 'src/constants';

export const ReferralFAQSection = () => {
  const { shouldShowFreeMonths } = useGetReferralsInfo();
  const isNewPlanPage = AVAILABLE_FEATURES_LIST.newSuperNinjaPlans;

  return (
    <div className={styles.root}>
      <h6 className={styles.title}>FAQ</h6>
      {shouldShowFreeMonths ? (
        <h6 className={styles.subheader}>
          How does the referral and reward program work?
        </h6>
      ) : (
        <h6 className={styles.subheader}>
          How does the referral program work?
        </h6>
      )}

      <span className={styles.text}>
        {shouldShowFreeMonths ? (
          <>
            When you invite friends to join Ninja using your unique referral
            link, both you and your friend receive benefits:
            <br />
            <ul>
              <li>
                <b>For you:</b>{' '}
                {isNewPlanPage
                  ? "You'll get one month of free subscription when your friend subscribes to a Standard, Ultra, Max, or Business membership through your referral link."
                  : "You'll get one month of free subscription when your friend subscribes to a Standard, Pro or Ultra membership through your referral link."}
              </li>
              <li>
                <b>For your friend:</b>{' '}
                {isNewPlanPage
                  ? "They'll receive their first month free on a Standard or Ultra subscription when they sign up using your referral link."
                  : "They'll receive their first month of subscription free when they sign up using your referral link."}
              </li>
              <li>
                Maximum reward: You can earn up to 12 months (1 year) of free
                subscription through successful referrals.
              </li>
            </ul>
          </>
        ) : isNewPlanPage ? (
          <p className={styles.businessAnswer}>
            Your friends get a free month when they use your link to join
            Standard or Ultra membership.
          </p>
        ) : (
          <p className={styles.businessAnswer}>
            Your friends get a free month when they use your link to join any
            Standard, Pro or Ultra membership.
          </p>
        )}
        <span>
          To start referring, simply share your unique referral link with
          friends and family who might be interested in Ninja.
        </span>
      </span>
    </div>
  );
};
